import React from 'react';
import formatMessage from 'format-message';
import { IconBulletListLine, IconTableCellSelectAllLine } from '@instructure/ui-icons';
import * as announce from '../../common/announce';
import Link from '../common/link';
import { getState } from '../../store';
import { CARD_VIEW, LIST_VIEW } from '../../constants/results-view';
import { updateResultsView } from '../../actions/local-storage';

const BUTTON_INFO = {
  [CARD_VIEW]: {
    icon: IconBulletListLine,
    label: formatMessage('Switch to list view'),
    switchedToMessage: formatMessage('Switched to Card View'),
  },
  [LIST_VIEW]: {
    icon: IconTableCellSelectAllLine,
    label: formatMessage('Switch to card view'),
    switchedToMessage: formatMessage('Switched to List View'),
  },
};

const getOppositeResultsView = (resultsView) => {
  return resultsView === CARD_VIEW ? LIST_VIEW : CARD_VIEW;
};

const ToggleResultsViewButton = () => {
  const currentResultsView = getState().localStorage.searchPage.resultsView;

  const handleOnClick = () => {
    const targetResultsView = getOppositeResultsView(currentResultsView);
    updateResultsView(targetResultsView);
    announce.politely(BUTTON_INFO[targetResultsView].switchedToMessage);
  };

  return (
    <Link
      renderIcon={BUTTON_INFO[currentResultsView].icon}
      onClick={handleOnClick}
      className="toggle-results-view-button"
      aria-label={BUTTON_INFO[currentResultsView].label}
    >
      {BUTTON_INFO[currentResultsView].label}
    </Link>
  );
};

export default ToggleResultsViewButton;
